export const logrocketId = process.env.VUE_APP_LOGROCKET_ID;
export const sentryDsn = process.env.VUE_APP_SENTRY_DSN;
export const seigyoMpcUrl = process.env.VUE_APP_SEIGYO_MPC_URL;
export const seigyoMcaUrl = process.env.VUE_APP_SEIGYO_MCA_URL;
